import apiHandler from "../core/apiHandler";

const excludedSubjectApi = apiHandler('excluded-subject-purchases');
export default excludedSubjectApi;
